import { useMemo } from 'react'
import { useIntl } from 'react-intl'

function useCarHireVehicleTypeLabels(): Record<App.CarHireVehicleType, string> {
  const intl = useIntl()

  return useMemo(() => ({
    SUV: intl.formatMessage({
      id: 'EOvlmsMNfq5q-OS3lhAD',
      defaultMessage: 'SUV',
      description: 'Vehicle type label for SUV cars in the car hire search and booking experience',
    }),
    Luxury: intl.formatMessage({
      id: '96iuQw8AzJTeRFhD0ctp',
      defaultMessage: 'Luxury',
      description: 'Vehicle type label for luxury cars in the car hire search and booking experience',
    }),
    Van: intl.formatMessage({
      id: 'bSgHnr38RsjUz1TNMQE4',
      defaultMessage: 'Van',
      description: 'Vehicle type label for vans in the car hire search and booking experience',
    }),
    Sedan: intl.formatMessage({
      id: 'oiN6XXhKHm5VoE2mvACA',
      defaultMessage: 'Sedan',
      description: 'Vehicle type label for sedans in the car hire search and booking experience',
    }),
    Compact: intl.formatMessage({
      id: 'Hm3EXmCKMI96YOdelhqp',
      defaultMessage: 'Compact',
      description: 'Vehicle type label for compact cars in the car hire search and booking experience',
    }),
    Truck: intl.formatMessage({
      id: 'VGH60si_pGmtksJb0-Jv',
      defaultMessage: 'Truck',
      description: 'Vehicle type label for trucks in the car hire search and booking experience',
    }),
    'Scooters and Bikes': intl.formatMessage({
      id: 'f_7Zbmj90VKT19r-JUwk',
      defaultMessage: 'Scooters and Bikes',
      description: 'Vehicle type label for scooters and bikes in the car hire search and booking experience',
    }),
    '4WD': intl.formatMessage({
      id: '76zoATv-S21gT_j--5nt',
      defaultMessage: '4WD',
      description: 'Vehicle type label for 4WD vehicles in the car hire search and booking experience',
    }),
    Convertible: intl.formatMessage({
      id: 'BMLFl3s6lqVPsX5JYLnk',
      defaultMessage: 'Convertible',
      description: 'Vehicle type label for convertibles in the car hire search and booking experience',
    }),
    Other: intl.formatMessage({
      id: '8125wDc0T126SrFvg0LO',
      defaultMessage: 'Other',
      description: 'Fallback vehicle type label for uncategorised cars in the car hire search and booking experience',
    }),
  }), [intl])
}

export default useCarHireVehicleTypeLabels
